// extracted by mini-css-extract-plugin
export default {"MainContainer":"ForgotPasswordModal_MainContainer__Ns6TJ","Form":"ForgotPasswordModal_Form__Hbysk"};